export const colorThemes: Record<
  string,
  {
    primaryColor: string;
    secondaryColor: string;
    blendRect1Color: string;
    blendRect2Color: string;
  }
> = {
  Blue: {
    primaryColor: "#0B2E73",
    secondaryColor: "#1646A5",
    blendRect1Color: "#0B2E73",
    blendRect2Color: "#0B2E73",
  },
  Brown: {
    primaryColor: "#6C2E02",
    secondaryColor: "#8C3A00",
    blendRect1Color: "#6C2E02",
    blendRect2Color: "#6C2E02",
  },
  Gray: {
    primaryColor: "#171717",
    secondaryColor: "#474242",
    blendRect1Color: "#474242",
    blendRect2Color: "#474242",
  },
  Green: {
    primaryColor: "#226600",
    secondaryColor: "#228800",
    blendRect1Color: "#226600",
    blendRect2Color: "#226600",
  },
  Magenta: {
    primaryColor: "#9A0470",
    secondaryColor: "#C3008C",
    blendRect1Color: "#481039",
    blendRect2Color: "#481039",
  },
  Purple: {
    primaryColor: "#5C26CA",
    secondaryColor: "#7D46EC",
    blendRect1Color: "#5C26CA",
    blendRect2Color: "#5C26CA",
  },
  Red: {
    primaryColor: "#990D0D",
    secondaryColor: "#CE0E00",
    blendRect1Color: "#420404",
    blendRect2Color: "#420404",
  },
  Tan: {
    primaryColor: "#8B4D01",
    secondaryColor: "#A25A02",
    blendRect1Color: "#7B4400",
    blendRect2Color: "#7B4400",
  },
  Teal: {
    primaryColor: "#045F75",
    secondaryColor: "#007996",
    blendRect1Color: "#045F75",
    blendRect2Color: "#045F75",
  },
  Violet: {
    primaryColor: "#7E08B7",
    secondaryColor: "#A61FE8",
    blendRect1Color: "#510078",
    blendRect2Color: "#510078",
  },
};
